import { createRequestActions } from "common/helpers/action";

export const initCpUsersAdd = createRequestActions("CP.USERS.ADD.INIT");
export const sendCpUsersAdd = createRequestActions("CP.USERS.ADD.SEND");
